 <template>
  <div>
  <div class="box4" :style="{height: openFlag && 'auto' }">
    <pageTitle
        title="定制指导流程"
        titleColor="#313433"
      /> 
    <img src="../../../assets/coursePage/design/box4/img01.png"/>
    <div class="mask-box" v-if="!openFlag" @click="openFlag = !openFlag">
        <span>展开</span>
        <i></i>
      </div>
   
  </div>
  <div class="bottom" v-if="!openFlag"></div>
</div>
</template>
 
<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  mounted() {},
  data() {
    return {
      openFlag: false,
    };
  },
  
};
</script>

<style lang="less" scoped>
 .bottom{
    height: 78px;
    background: #E6F6FF;
  }
.box4 {
  width:100%;
  background: #E6F6FF;
  padding: 0 40px 88px 52px;
  height: 1006px;
  box-sizing: border-box;
  overflow: hidden;
  position:relative;
 
img{
  width:1370px;
  margin-top: 50px ;
  display: block;
}
.mask-box{
      z-index: 1;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 104px;
      background-image: linear-gradient(  rgba(230,246,255,0.0) 0%, #E6F6FF 100%, #E6F6FF 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 40px;
      box-sizing: border-box;
      span{
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #303433;
        line-height: 36px;
      }
      i{
        width: 32px;
        height: 32px;
        background-image: url(../../../assets/coursePage/fcp/box12/icon-open.png);
        background-size: 20px 20px;
        background-position: center;
        background-repeat: no-repeat;
        margin-left: 8px;
      }
    }
}
</style>
